<div class="survey-info-step-content">
  <div class="survey-info-step-title">{{ getLangValue(stepData?.title) }}</div>
  <div class="survey-info-step-description" [innerHTML]="getLangValue(stepData?.description)"></div>
  <ng-container *ngIf="!manualMode">
    <div class="address-search-row">
      <input id="address-input" type="text" #addressInputEl [(ngModel)]="addressInput" (keydown.enter)="onAddressInputChange(addressInputEl.value)" (blur)="onAddressInputChange(addressInputEl.value)" autocomplete="off" class="survey-text-input" [placeholder]="'address-survey.addressInput' | translate" />
      <span class="search-icon" (click)="onAddressInputChange(addressInputEl.value)" tabindex="0" role="button" [attr.aria-label]="'address-survey.searchAddress' | translate">🔍</span>
    </div>
    <div *ngIf="loading">{{ 'address-survey.loading' | translate }}</div>
    <ul *ngIf="suggestions.length > 0" style="max-height: 150px; overflow-y: auto;">
      <li *ngFor="let suggestion of suggestions" (click)="selectSuggestion(suggestion)">
        {{ suggestion.formatted_address }}
      </li>
    </ul>
    <button type="button" (click)="useManualMode()" class="survey-text-input" style="width:auto;cursor:pointer;">{{ 'address-survey.cantFindAddress' | translate }}</button>
  </ng-container>
  <ng-container *ngIf="manualMode">
    <mat-form-field appearance="outline" class="full-width mt-3">
      <mat-label>{{ 'address-survey.country' | translate }}</mat-label>
      <mat-select [(ngModel)]="selectedCountry" (selectionChange)="onCountrySelect($event.value)">
        <mat-option *ngFor="let country of countries" [value]="country">{{ country.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width" *ngIf="states.length">
      <mat-label>{{ 'address-survey.stateOrProvince' | translate }}</mat-label>
      <input matInput [(ngModel)]="stateSearch" (ngModelChange)="onStateSearchChange($event)" [matAutocomplete]="autoState" [placeholder]="('address-survey.stateOrProvince' | translate)" />
      <mat-autocomplete #autoState="matAutocomplete" (optionSelected)="onStateSelect($event.option.value)">
        <mat-option *ngFor="let state of filteredStates.length ? filteredStates : states" [value]="state">{{ state.name }}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width" *ngIf="cities.length">
      <mat-label>{{ 'address-survey.city' | translate }}</mat-label>
      <input matInput [(ngModel)]="citySearch" (ngModelChange)="onCitySearchChange($event)" [matAutocomplete]="autoCity" [placeholder]="('address-survey.city' | translate)" />
      <mat-autocomplete #autoCity="matAutocomplete" (optionSelected)="onCitySelect($event.option.value)">
        <mat-option *ngFor="let city of filteredCities.length ? filteredCities : cities" [value]="city">{{ city.name }}</mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'address-survey.street' | translate }}</mat-label>
      <input matInput [(ngModel)]="manualAddress.Street" (ngModelChange)="onManualFieldChange()" [placeholder]="('address-survey.street' | translate)" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'address-survey.addressLine2' | translate }}</mat-label>
      <input matInput [(ngModel)]="manualAddress.Line3" (ngModelChange)="onManualFieldChange()" [placeholder]="('address-survey.addressLine2' | translate)" />
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'address-survey.postalCode' | translate }}</mat-label>
      <input matInput [(ngModel)]="manualAddress.PostalCode" (ngModelChange)="onManualFieldChange()" [placeholder]="('address-survey.postalCode' | translate)" />
    </mat-form-field>
  </ng-container>
</div>
